import useResponsive from './useResponsive';

export default function useModalSize() {
  const { isMobile } = useResponsive();
  return { modalWidth: isMobile ? '95%' : undefined };
}


